//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, litigationDocketCaseUrl } from "@/services/constants";
import TimeLineOperations from "../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import Swal from 'sweetalert2'
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");

// ค่าการตัดสินใจของลูกค้า (เก็บลง DB เป็น string)
const DECISION = {
    AWAITING: "awaiting",
    PROCEED: "proceed",
    DECLINED: "declined",
};

export default {
    name: "CaseDocket",
    data() {
        return {
            quotationscheckstatus: '',
            statusCloseEditMode: false,
            invoiceList: [],
            invoiceSelectList: [],
            invoiceMenu: false,
            invoiceMenuPay: false,
            formValid: false,
            // date pickers ของ Section A
            adviceDateMenu: false,
            decisionDateMenu: false,
            form: {
                // ---------- A · Advice & Client Decision ----------
                adviceDate: moment().format("YYYY-MM-DD"),
                advisingLawyerId: null,
                adviceStatus: "draft",
                adviceSummary: "",
                recommendedAction: "",
                clientDecision: DECISION.AWAITING,
                decisionDate: "",
                clientNote: "",
                // ---------- B · Case Identification ----------
                internalCaseNo: "",
                blackNo: "",
                clientId: null,
                redNo: "",
                charge: "",
                court: null,
                department: null,
                caseType: null,
                courtLevel: "ศาลชั้นต้น",
                lawyerId: null,
                claimAmount: "",
                plaintiffs: "",
                defendants: "",
                hearings: [{ id: 0, topic: "", date: "", time: "", menu: false }],
                remark: "",
                caseStatus: 0,
                customerName: "",
                currency: "",
                salesOrderId: "",
                price: "",
                invoiceStatus: "",
                invoiceNo: "",
                invoiceId: "",
                invoiceDate: "",
                dueDate: "",
                files: [],
            },
            // ข้อความที่แสดงในช่องทุนทรัพย์ (มี , คั่นหลักพัน)
            claimAmountDisplay: "",
            // รหัสคดีที่โหลดมาจาก server (ใช้เตือนก่อนเปลี่ยนเป็น Do not proceed)
            originalInternalCaseNo: "",
            adviceStatusList: [
                { value: "draft", text: "Draft / ร่าง" },
                { value: "in_preparation", text: "In preparation / กำลังจัดทำ" },
                { value: "under_review", text: "Under review / อยู่ระหว่างตรวจสอบ" },
                { value: "approved", text: "Approved / อนุมัติแล้ว" },
                { value: "provided", text: "Provided to client / ส่งคำแนะนำให้ลูกค้าแล้ว" },
                { value: "withdrawn", text: "Withdrawn / ยกเลิก" },
            ],
            clientDecisionOptions: [
                { value: DECISION.AWAITING, label: "Awaiting decision" },
                { value: DECISION.PROCEED, label: "Proceed with case" },
                { value: DECISION.DECLINED, label: "Do not proceed" },
            ],
            deletedHearings: [],
            pendingFiles: [],
            additionalLawyers: [],
            originalAdditionalLawyers: [],
            showCoLawyer: false,
            clientList: [],
            courtList: [],
            departmentList: [],
            caseTypeList: [],
            courtLevelList: [],
            lawyerList: [],
            salesOrderList: [],
            invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],

            rules: {
                required: (v) => !!v || "จำเป็นต้องกรอก",
            },
            deletedFiles: [],
            //timeline
            timelineStatus: 0,
            status_note: "",
            visible_check: false,
            dialogDelete: false,
            timeline_case_id: 0,
            module_name: "Dispute Resolution",
            modeOperations: "",
            tabselect: 0,
            reportlist: [],
            statuslist: [],

        };
    },
    components: {
        TimeLineOperations,
        InvoiceSectionPanel
    },
    computed: {
        nonCloseStatus() {
            return this.modeOperations === "Edit" ? !this.statusCloseEditMode : true;
        },
        // ---------- สถานะการตัดสินใจของลูกค้า ----------
        isAwaiting() {
            return this.form.clientDecision === DECISION.AWAITING;
        },
        isProceed() {
            return this.form.clientDecision === DECISION.PROCEED;
        },
        isDeclined() {
            return this.form.clientDecision === DECISION.DECLINED;
        },
        // ช่องใน Case Identification / คู่ความ / วันนัด / เอกสารแนบ กรอกได้เฉพาะ Proceed with case
        caseLocked() {
            return !this.isProceed;
        },
        // Do not proceed และไม่มีข้อมูลคดี → ช่องลูกค้าถูกซ่อน ให้ลูกค้าตาม Sales Order
        clientFollowsSO() {
            return this.isDeclined && !this.hasCaseData;
        },
        // คดีนี้มีข้อมูล Case Identification อยู่แล้วหรือไม่
        // → ถ้ามี จะไม่ล้างทิ้งไม่ว่าลูกค้าตัดสินใจแบบไหน (Do not proceed แสดงแบบ read-only)
        // หมายเหตุ: ไม่นับ clientId เพราะ Do not proceed ตั้งลูกค้าอัตโนมัติจาก Sales Order
        hasCaseData() {
            const f = this.form;
            const filled = (v) => v !== null && v !== undefined && String(v).trim() !== "";
            return (
                filled(f.internalCaseNo) ||
                filled(f.blackNo) ||
                filled(f.redNo) ||
                filled(f.charge) ||
                filled(f.court) ||
                filled(f.department) ||
                filled(f.caseType) ||
                filled(f.claimAmount) ||
                filled(f.lawyerId) ||
                filled(f.plaintiffs) ||
                filled(f.defendants) ||
                filled(f.remark) ||
                f.files.length > 0 ||
                this.additionalLawyers.length > 0 ||
                f.hearings.some(h => (h.id && h.id !== 0) || filled(h.topic) || filled(h.date))
            );
        },
        // ช่อง required ของคดี บังคับเฉพาะตอน Proceed เท่านั้น
        caseRequiredRules() {
            return this.isProceed ? [this.rules.required] : [];
        },
        requestPaymentDisabled() {
            const price = Number(this.form.price);
            const salesOrderId = Number(this.form.salesOrderId);
            const customerID = Number(this.form.clientId);

            const isPriceValid = !isNaN(price) && price > 0;
            const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
            const isCustomerIdValid = !isNaN(customerID) && customerID > 0;

            // วางบิลได้ทุกสถานะยกเว้น Awaiting decision (ล็อกอยู่)
            return !(!this.isAwaiting && isPriceValid && isSalesOrderIdValid && isCustomerIdValid);
        },
        coLawyerList() {
            // ตัดทนายหลักออกจากตัวเลือกทนายร่วม
            return this.lawyerList.filter(l => l.id !== this.form.lawyerId);
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            // ----------------- Check Authorize ID ---------------------------
            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            // ----------------- Resolve Current Route Path -------------------
            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            // ----------------- Fetch Authorization --------------------------
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            // ----------------- Check Login Status ---------------------------
            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }

            await this.loaddataLitigationCourt()
            await this.loaddataLitigationCourtLevel()
            await this.loaddataLitigationCourtCasetype()
            await this.loaddataLitigationCourtDepartment()
            await this.loaddataClientList()
            await this.loaddataLawyerList()
            await this.loaddataSalesOrder()
            await this.loadDataInvoiceSelect()
            await this.loaddataLitigationCourtStatus()
            // ----------------- Resolve Mode (New / Edit) --------------------
            const id = this.$route.params.id;
            if (id === "new") {
                // โหมดสร้างใหม่ — เริ่มที่ Awaiting decision, ยังไม่ออกรหัสคดี
                this.modeOperations = "New";
            } else {
                // โหมดแก้ไข — id เป็นตัวเลข
                this.modeOperations = "Edit";
                this.timeline_case_id = Number(id);
                await this.loadData(id);
                await this.loadFile(id);
                await this.loadAdditionalLawyers(id);
                await this.loadHearings(id);
                await this.loadDataInvoice(id);
            }

        } catch (error) {
            console.error("mounted() error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        } finally {
            this.$hideLoader();
        }
    },
    beforeRouteUpdate(to, from, next) {
        // route เปลี่ยน id แต่ component ตัวเดิม -> สั่งรีโหลดหน้าทั้งหมด
        next();
        location.reload();
    },
    methods: {

        async loaddataLitigationCourt() {
            try {
                const res = await api.dispute_resolution_getall_court();
                this.courtList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourt error:", error);
            }
        },

        async loaddataLitigationCourtLevel() {
            try {
                const res = await api.dispute_resolution_getall_courtlevel();
                this.courtLevelList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtLevel error:", error);
            }
        },
        async loaddataLitigationCourtCasetype() {
            try {
                const res = await api.dispute_resolution_getall_courttype();
                this.caseTypeList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtCasetype error:", error);
            }
        },
        async loaddataLitigationCourtDepartment() {
            try {
                const res = await api.dispute_resolution_getall_courtdepartment();
                this.departmentList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtDepartment error:", error);
            }
        },
        async loaddataClientList() {
            try {
                const res = await api.dispute_resolution_get_clienList(Number(localStorage.getItem(server.COMPANYID)));
                this.clientList = res.data || [];
            } catch (error) {
                console.error("loaddataClientList error:", error);
            }
        },
        async loaddataLawyerList() {
            try {
                const res = await api.dispute_resolution_get_lawyerList(Number(localStorage.getItem(server.COMPANYID)));
                this.lawyerList = res.data.data || [];
            } catch (error) {
                console.error("loaddataLawyerList error:", error);
            }
        },
        async loaddataSalesOrder() {
            try {
                const res = await api.dispute_resolution_get_quotationsList(Number(localStorage.getItem(server.COMPANYID)));
                this.salesOrderList = res.data.data || [];

            } catch (error) {
                console.error("loaddataSalesOrder error:", error);
            }
        },
        async loadData(id) {
            try {
                const res = await api.dispute_resolution_getbyid_docket(Number(id));
                const d = res.data[0];

                // ---------- A · Advice & Client Decision ----------
                this.form.adviceDate = d.advice_date ? String(d.advice_date).slice(0, 10) : "";
                this.form.advisingLawyerId = d.advising_lawyer_id || null;
                this.form.adviceStatus = d.advice_status || "draft";
                this.form.adviceSummary = d.advice_summary || "";
                this.form.recommendedAction = d.recommended_action || "";
                // ข้อมูลเก่าก่อนมีฟีเจอร์นี้ (ไม่มี client_decision) แต่มีรหัสคดีแล้ว → ถือว่า Proceed
                this.form.clientDecision = d.client_decision
                    || (d.internal_case_no ? DECISION.PROCEED : DECISION.AWAITING);
                this.form.decisionDate = d.decision_date ? String(d.decision_date).slice(0, 10) : "";
                this.form.clientNote = d.client_note || "";

                // ---------- B · Case Identification ----------
                this.form.internalCaseNo = d.internal_case_no || "";
                this.originalInternalCaseNo = this.form.internalCaseNo;
                this.form.blackNo = d.black_no || "";
                this.form.clientId = d.client_id || null;
                this.form.redNo = d.red_no || "";
                this.form.charge = d.charge || "";
                this.form.court = d.court ?? null;
                this.form.department = d.department ?? null;
                this.form.caseType = d.case_type ?? null;
                this.form.courtLevel = d.court_level ?? "ศาลชั้นต้น";
                this.form.lawyerId = d.lawyer_id || null;
                this.form.claimAmount = d.claim_amount != null ? this.normalizeAmount(d.claim_amount) : "";
                this.claimAmountDisplay = this.formatAmount(this.form.claimAmount);
                this.form.plaintiffs = d.plaintiffs || "";
                this.form.defendants = d.defendants || "";
                this.form.remark = d.remark || "";
                this.form.caseStatus = d.case_status != null ? Number(d.case_status) : 0;

                const selectedItem = this.statuslist.find(
                    item => Number(item.module_id) === Number(this.form.caseStatus)
                );
                if (selectedItem) {
                    this.statusCloseEditMode = selectedItem.status === "ปิดคดี";
                    this.timelineStatus = Number(selectedItem.timeline_status_id);
                } else {
                    this.statusCloseEditMode = false;
                    this.timelineStatus = 0;
                }

                this.form.salesOrderId = d.sales_order_id || "";
                // ค้น object เองตอนโหลดข้อมูลเดิม เพราะไม่ได้ผ่าน event จาก component
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                this.onSelectSO(so || null);
            } catch (error) {
                console.error("loadData error:", error);
            }
        },
        async loadAdditionalLawyers(id) {
            try {
                const res = await api.dispute_resolution_getbyid_additional_lawyers(id)
                this.additionalLawyers = res.data.map(item => item.user_id);
                this.originalAdditionalLawyers = [...this.additionalLawyers]; // เก็บค่าเดิม
                if (this.additionalLawyers.length > 0) {
                    this.showCoLawyer = true;
                }
            } catch (error) {
                console.error("loadAdditionalLawyers error:", error);
            }
        },
        async loadHearings(id) {
            try {
                const res = await api.dispute_resolution_getbyid_hearings(id)
                const rows = (res.data || []).map(item => ({
                    id: item.id,
                    topic: item.topic || "",
                    date: item.date ? String(item.date).slice(0, 10) : "",
                    time: item.time ? item.time.slice(0, 5) : "",
                    menu: false,
                }));
                // กันลิสต์ว่าง — ให้มีแถวเปล่าไว้กรอกเสมอ
                this.form.hearings = rows.length
                    ? rows
                    : [{ id: 0, topic: "", date: "", time: "", menu: false }];

            } catch (error) {
                console.error("loadHearings error:", error);
            }
        },
        async loadDataInvoice(id) {
            try {
                var dataserach = {
                    module_name: 'Litigations',
                    module_id: id,
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                }
                const res = await api.dispute_resolution_get_invoiceList({
                    params: dataserach
                })
                this.invoiceList = res.data.data || [];
            } catch (error) {
                console.error("loadDataInvoice error:", error);
            }
        },
        async loadDataInvoiceSelect() {
            try {
                const id = this.$route.params.id;
                const isEdit = id && id !== "new";
                const res = await api.billing_expense_getInvoiceSelectList(
                    Number(localStorage.getItem(server.COMPANYID)),
                    isEdit ? "Litigations" : null,
                    isEdit ? Number(id) : null
                );
                this.invoiceSelectList = res.data.data || [];
            } catch (error) {
                console.error("loadDataInvoiceSelect error:", error);
            }
        },
        async loadFile(id) {
            try {
                const res = await api.dispute_resolution_load_file(id, Number(localStorage.getItem(server.COMPANYID)));

                this.form.files = (res.data || []).map(item => ({
                    id: item.id,
                    name: item.file_name,
                    url: `${litigationDocketCaseUrl}/${item.module_id}/${item.file_name}`,
                    raw: null,        // ไฟล์เดิมจาก server ไม่มี raw
                    isExisting: true, // ธงบอกว่าเป็นไฟล์เก่า (เผื่อ logic ตอน save/delete)
                }));
            } catch (error) {
                console.error("loadFile error:", error);
            }
        },
        //timelinestatus
        closeDelete() {
            this.dialogDelete = false;
        },
        deleteItemConfirm() {
            this.tabselect = 1;
            this.dialogDelete = false;
        },

        handleRequestStatus(value) {
            this.form.caseStatus = Number(value)
        },
        sendToStatus(value) {
            const selectedItem = this.statuslist.find(
                item => item.module_id === value
            )
            this.timelineStatus = selectedItem ? Number(selectedItem.timeline_status_id) : 0
        },
        previewInvoice(item) {
            const routeData = this.$router.resolve(
                `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
            );
            window.open(routeData.href, '_blank');
        },
        async loaddataLitigationCourtStatus() {
            const result = await api.getClientTimelineStatusCongFigByModule("Dispute Resolution");

            this.statuslist = (result.data || []).map(item => ({
                ...item,
                module_id: Number(item.module_id)
            }));

        },
        //end

        // ---------- A · Client decision ----------
        async setClientDecision(value) {
            if (!this.nonCloseStatus || value === this.form.clientDecision) return;

            // ข้อมูลคดีเดิมจะถูกเก็บไว้เสมอ (Do not proceed แสดงแบบ read-only) จึงไม่ต้องยืนยันก่อนเปลี่ยน
            this.form.clientDecision = value;

            if (value === DECISION.AWAITING) {
                // ยังไม่ได้ตัดสินใจ → ไม่มีวันที่ตัดสินใจ
                this.form.decisionDate = "";
            } else if (!this.form.decisionDate) {
                this.form.decisionDate = moment().format("YYYY-MM-DD");
            }

            // Do not proceed: ถ้าเลือก Sales Order ไว้แล้ว → ใช้ลูกค้าตาม SO สำหรับวางบิล
            if (this.clientFollowsSO && this.form.salesOrderId) {
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                if (so && so.client_id) this.form.clientId = Number(so.client_id);
            }

            // Proceed: ตั้งทนายผู้รับผิดชอบเริ่มต้นเป็นผู้ให้คำปรึกษา (แก้ได้)
            if (value === DECISION.PROCEED && !this.form.lawyerId && this.form.advisingLawyerId) {
                this.form.lawyerId = this.form.advisingLawyerId;
            }
        },

        // ---------- ทุนทรัพย์: ใส่ , คั่นหลักพันระหว่างพิมพ์ ----------
        // ล้างให้เหลือเฉพาะตัวเลข + จุดทศนิยม 1 จุด (ไม่เกิน 2 ตำแหน่ง) เช่น "1,234.567" → "1234.56"
        normalizeAmount(value) {
            let s = String(value ?? "").replace(/[^\d.]/g, "");
            const dot = s.indexOf(".");
            if (dot !== -1) {
                s = s.slice(0, dot + 1) + s.slice(dot + 1).replace(/\./g, "").slice(0, 2);
            }
            s = s.replace(/^0+(?=\d)/, "");   // ตัด 0 นำหน้า เช่น "007" → "7"
            if (s.startsWith(".")) s = "0" + s; // ".5" → "0.5"
            return s;
        },
        // "1234567.5" → "1,234,567.5"
        formatAmount(raw) {
            if (raw === "" || raw == null) return "";
            const [intPart, decPart] = String(raw).split(".");
            const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return decPart !== undefined ? `${intFmt}.${decPart}` : intFmt;
        },
        onClaimAmountInput(value) {
            const field = this.$refs.claimAmountInput;
            const el = field?.$refs?.input;
            const typed = String(value ?? "");

            // นับจำนวนตัวเลข/จุด ที่อยู่ซ้ายของ cursor เพื่อคืนตำแหน่ง cursor หลังจัดรูปแบบ
            const caret = el ? el.selectionStart : null;
            const sigLeft = caret == null
                ? null
                : typed.slice(0, caret).replace(/[^\d.]/g, "").length;

            const raw = this.normalizeAmount(typed);
            const formatted = this.formatAmount(raw);

            this.form.claimAmount = raw;          // ค่าจริงที่ส่งไป API (ไม่มี ,)
            this.claimAmountDisplay = formatted;

            this.$nextTick(() => {
                if (!el) return;
                // บังคับ sync กรณีพิมพ์ตัวอักษรที่ถูกตัดทิ้ง (ค่า display ไม่เปลี่ยน Vue จึงไม่ re-render)
                if (field && "lazyValue" in field) field.lazyValue = formatted;
                el.value = formatted;

                if (sigLeft == null || document.activeElement !== el) return;
                let pos = 0;
                let seen = 0;
                while (pos < formatted.length && seen < sigLeft) {
                    if (/[\d.]/.test(formatted[pos])) seen++;
                    pos++;
                }
                el.setSelectionRange(pos, pos);
            });
        },
        onClaimAmountBlur() {
            // ตัดจุดที่ค้างท้าย เช่น "1,000." → "1,000"
            if (String(this.form.claimAmount).endsWith(".")) {
                this.form.claimAmount = this.form.claimAmount.slice(0, -1);
            }
            this.claimAmountDisplay = this.formatAmount(this.form.claimAmount);
        },

        openTimePicker(event) {
            const input = event.target.closest('.v-text-field')?.querySelector('input[type="time"]');
            if (input && typeof input.showPicker === 'function') {
                input.showPicker();
            }
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = String(date).slice(0, 10).split("-");
            return `${day}/${month}/${year}`;
        },
        onMainLawyerChange() {
            if (!this.form.lawyerId) {
                // ถ้าล้างทนายหลัก ปิดช่องทนายร่วม + เคลียร์
                this.showCoLawyer = false;
                this.additionalLawyers = [];
                return;
            }
            // ถ้าเลือกทนายหลักชนกับทนายร่วม ให้ดึงออก
            this.additionalLawyers = this.additionalLawyers.filter(
                id => id !== this.form.lawyerId
            );
        },
        closeCoLawyer() {
            this.showCoLawyer = false;
            this.additionalLawyers = [];
        },
        addHearing() {
            this.form.hearings.push({ id: 0, topic: "", date: "", time: "", menu: false });
        },
        removeHearing(index) {
            const h = this.form.hearings[index];
            if (h.id && h.id !== 0) {
                this.deletedHearings.push(h.id);
            }
            this.form.hearings.splice(index, 1);
            // กันลิสต์ว่าง — ให้มีแถวเปล่าไว้กรอกเสมอ
            if (this.form.hearings.length === 0) {
                this.form.hearings.push({ id: 0, topic: "", date: "", time: "", menu: false });
            }
        },
        onFilesSelected(files) {
            if (!files || !files.length) return;
            const list = Array.isArray(files) ? files : [files];

            list.forEach(file => {
                if (file.type !== 'application/pdf') return;   // ✅ เช็คในนี้ ทีละไฟล์

                const uniqueName = this.getUniqueName(file.name);
                const finalFile = uniqueName === file.name
                    ? file
                    : new File([file], uniqueName, { type: file.type });

                this.form.files.push({
                    name: uniqueName,
                    raw: finalFile,
                    url: URL.createObjectURL(finalFile),
                });
            });

            this.pendingFiles = [];
        },

        getUniqueName(name) {
            const existing = this.form.files.map(f => f.name);
            if (!existing.includes(name)) return name;

            // แยกชื่อกับนามสกุล
            const dot = name.lastIndexOf('.');
            const base = dot === -1 ? name : name.slice(0, dot);
            const ext = dot === -1 ? '' : name.slice(dot);

            let i = 1;
            let candidate = `${base}_${i}${ext}`;
            while (existing.includes(candidate)) {
                i++;
                candidate = `${base}_${i}${ext}`;
            }
            return candidate;
        },

        previewFile(f) {
            // เปิด PDF ในแท็บใหม่
            window.open(f.url, '_blank');
        },

        removeFile(index) {
            const f = this.form.files[index];

            if (f.isExisting) {
                // ไฟล์เก่าจาก server → จำไว้เพื่อไปลบตอน save
                this.deletedFiles.push({
                    id: f.id,
                    name: f.name,
                });
            } else if (f.url) {
                // ไฟล์ใหม่ → คืน memory ของ object URL
                URL.revokeObjectURL(f.url);
            }

            this.form.files.splice(index, 1);
        },
        onSelectSO(so) {
            // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
            if (!so) {
                this.form.price = "";
                this.form.customerName = "";
                this.form.currency = "";
                this.quotationscheckstatus = "";
                // Do not proceed (ไม่มีข้อมูลคดี): ลูกค้ามาจาก SO → เคลียร์ตาม
                if (this.clientFollowsSO) this.form.clientId = null;
                return;
            }
            // Do not proceed (ไม่มีข้อมูลคดี): ช่องลูกค้าถูกซ่อน → ใช้ลูกค้าจาก Sales Order สำหรับวางบิล
            if (this.clientFollowsSO && so.client_id) {
                this.form.clientId = Number(so.client_id);
            }
            this.quotationscheckstatus = so.status;
            this.form.price = Number(so.subtotal);
            this.form.customerName = so.customer_name || "";
            this.form.currency = so.currency || "";
        },

        // ตรวจช่องบังคับจาก "ข้อมูล" โดยตรง ไม่พึ่ง v-form
        // เพราะตอนอยู่แท็บ Internal Timeline ช่องในแท็บ Internal Work ไม่ได้ render → validate() ผ่านเสมอ
        getMissingRequiredFields() {
            const f = this.form;
            const isEmpty = (v) => v === null || v === undefined || String(v).trim() === "";
            const missing = [];   // [{ section: "A" | "B", label }]
            const add = (section, label) => missing.push({ section, label });

            // A · Advice & Client Decision
            if (isEmpty(f.adviceDate)) add("A", "วันที่ให้คำปรึกษา (Advice date)");
            if (isEmpty(f.advisingLawyerId)) add("A", "ผู้ให้คำปรึกษา (Advising lawyer)");
            if (isEmpty(f.adviceSummary)) add("A", "สรุปคำแนะนำ (Advice summary)");
            if (isEmpty(f.clientDecision)) add("A", "การตัดสินใจของลูกค้า (Client decision)");
            if (this.isDeclined && isEmpty(f.clientNote)) {
                add("A", "เหตุผล / หมายเหตุจากลูกค้า (Reason / client note)");
            }

            // B · Case Identification — บังคับเฉพาะ Proceed with case
            if (this.isProceed) {
                if (isEmpty(f.clientId)) add("B", "ลูกค้า (Client)");
                if (isEmpty(f.lawyerId)) add("B", "ทนายผู้รับผิดชอบ");
            }
            return missing;
        },

        // dialog แจ้งเตือนกรอกข้อมูลไม่ครบ — ปุ่มสีเดียวกับ SAVE (navy #0e3a5f)
        // หมายเหตุ: Swal render นอก component → ใช้ inline style (scoped CSS ไม่มีผล)
        showMissingFieldsDialog(missing = []) {
            const sectionTitles = {
                A: "A · คำปรึกษาและการตัดสินใจของลูกค้า",
                B: "B · ข้อมูลคดี",
            };

            const groupsHtml = Object.keys(sectionTitles)
                .map(sec => {
                    const items = missing.filter(m => m.section === sec);
                    if (!items.length) return "";
                    const rows = items.map(m => `
                        <div style="display:flex;align-items:center;gap:10px;padding:6px 0;">
                            <span style="flex:0 0 auto;width:6px;height:6px;border-radius:50%;background:#c0392b;"></span>
                            <span style="color:#1f2733;font-size:13.5px;">${m.label}</span>
                        </div>`).join("");
                    return `
                        <div style="text-align:left;background:#f7f9fb;border:1px solid #e2e6ec;
                                    border-left:3px solid #1b7a99;border-radius:8px;
                                    padding:10px 14px;margin-top:10px;">
                            <div style="font-size:11px;font-weight:700;letter-spacing:.8px;
                                        text-transform:uppercase;color:#1b7a99;margin-bottom:2px;">
                                ${sectionTitles[sec]}
                            </div>
                            ${rows}
                        </div>`;
                })
                .join("");

            const subtitle = missing.length
                ? `ยังขาดข้อมูลที่จำเป็น <b style="color:#c0392b">${missing.length} รายการ</b> กรุณากรอกให้ครบก่อนบันทึก`
                : `โปรดกรอกช่องที่มีเครื่องหมาย <b style="color:#c0392b">*</b> ให้ครบก่อนบันทึก`;

            return Swal.fire({
                icon: "warning",
                iconColor: "#c47f00",
                title: "กรุณากรอกข้อมูลให้ครบ",
                html: `
                    <div style="font-size:14px;color:#4a5563;">${subtitle}</div>
                    ${groupsHtml}`,
                width: 480,
                padding: "1.6em 1.6em 1.4em",
                confirmButtonText: "ตกลง",
                // ปิดสไตล์ปุ่มของ Swal ทั้งหมด (กัน theme ของ Swal / global CSS ทับสี) แล้วกำหนดเองให้เหมือน SAVE
                buttonsStyling: false,
                focusConfirm: false,
                didOpen: () => {
                    const btn = Swal.getConfirmButton();
                    if (!btn) return;

                    // ดึงสีจริงจากปุ่ม SAVE บนหน้า → ได้สีเดียวกันแน่นอนแม้ theme จะเปลี่ยน
                    const saveBtn = this.$el && this.$el.querySelector(".navy-btn");
                    const saveStyle = saveBtn ? window.getComputedStyle(saveBtn) : null;
                    const bg = (saveStyle && saveStyle.backgroundColor
                        && saveStyle.backgroundColor !== "rgba(0, 0, 0, 0)")
                        ? saveStyle.backgroundColor
                        : "#0e3a5f";
                    const fg = saveStyle ? saveStyle.color : "#ffffff";

                    const set = (prop, value) => btn.style.setProperty(prop, value, "important");
                    set("background-color", bg);
                    set("background-image", "none");
                    set("color", fg);
                    set("border", "none");
                    set("border-radius", "4px");
                    set("min-width", "120px");
                    set("height", "36px");
                    set("padding", "0 32px");
                    set("font-size", "14px");
                    set("font-weight", "500");
                    set("letter-spacing", "1.25px");
                    set("text-transform", "uppercase");
                    set("box-shadow", "none");
                    set("cursor", "pointer");
                    set("margin", "8px 0 0");

                    // hover เข้มขึ้นเล็กน้อยแบบ v-btn
                    btn.addEventListener("mouseenter", () => set("filter", "brightness(1.15)"));
                    btn.addEventListener("mouseleave", () => set("filter", "none"));
                    const title = Swal.getTitle();
                    if (title) Object.assign(title.style, {
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#1f2733",
                    });
                },
            });
        },

        async onSave(mode) {

            // ----- ดักช่องบังคับก่อน (ทำงานได้ทั้งจากแท็บ Internal Work และ Internal Timeline) -----
            const missing = this.getMissingRequiredFields();
            if (missing.length > 0) {
                // พากลับไปแท็บ Internal Work แล้วให้ v-form ขึ้นกรอบแดงตรงช่องที่ขาด
                this.tabselect = 0;
                await this.$nextTick();
                this.$refs.form && this.$refs.form.validate();
                await this.$nextTick();
                const firstError = this.$el.querySelector(".error--text");
                if (firstError) firstError.scrollIntoView({ behavior: "smooth", block: "center" });

                this.showMissingFieldsDialog(missing);
                return;
            }

            if (this.$refs.form.validate()) {


                // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่เลือกในคดีนี้
                // กันเคสผูก Quotation ของลูกค้าคนอื่นเข้ากับคดี ทำให้วางบิลผิดคน
                // (Awaiting ล็อกอยู่ ไม่ต้องตรวจ)
                if (!this.isAwaiting && this.form.salesOrderId) {
                    const selectedSO = this.salesOrderList.find(
                        item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                    );

                    if (!selectedSO) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }

                    // Do not proceed (ไม่มีข้อมูลคดี): ไม่มีช่องเลือกลูกค้า → ผูกลูกค้าตาม Sales Order
                    // ถ้ามีข้อมูลคดีอยู่แล้ว ใช้ลูกค้าเดิมของคดี และตรวจว่าตรงกับ SO ตามปกติ
                    if (this.clientFollowsSO) {
                        this.form.clientId = Number(selectedSO.client_id);
                    }

                    if (Number(selectedSO.client_id) !== Number(this.form.clientId)) {
                        Swal.fire({
                            icon: "warning",
                            title: "ข้อมูลลูกค้าไม่ตรงกัน",
                            html: `ใบเสนอราคา <b>${selectedSO.doc_no}</b> เป็นของลูกค้า <b>${selectedSO.customer_name || "-"}</b><br/>
                           ซึ่งไม่ตรงกับลูกค้าที่เลือกในคดีนี้<br/>
                           กรุณาตรวจสอบและเลือกใหม่ให้ถูกต้อง`,
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                }
                if (this.timelineStatus == 0 || this.status_note.trim() == "") {
                    this.dialogDelete = true;
                    return;
                }
                // helper: แปลง string ว่าง / undefined ให้เป็น null
                const toNull = (v) => (v === "" || v === undefined || v === null ? null : v);
                // helper: แปลงเป็นตัวเลข ถ้าว่างเป็น null
                const toNumber = (v) => {
                    if (v === "" || v === undefined || v === null) return null;
                    const n = Number(v);
                    return isNaN(n) ? null : n;
                };
                // ข้อมูลคดีเก็บตามที่มีอยู่เสมอ ไม่ว่าลูกค้าจะตัดสินใจแบบไหน (ไม่ล้างทิ้ง)
                const caseVal = (v) => v;

                // ---------- รหัสคดีภายใน ----------
                // ออกเลขรันใหม่เฉพาะเมื่อ Proceed และยังไม่เคยมีรหัส
                // รหัสเดิมเก็บไว้เสมอ (รวมถึงตอนเปลี่ยนเป็น Do not proceed / Awaiting)
                let internalCaseNo = this.form.internalCaseNo || null;
                if (this.isProceed && !internalCaseNo) {
                    const resdoc = await api.dispute_resolution_get_docruningDocket(Number(localStorage.getItem(server.COMPANYID)));
                    internalCaseNo = resdoc.data.data || null;
                    this.form.internalCaseNo = internalCaseNo || "";
                }

                var datalist = {
                    // ---------- A · Advice & Client Decision ----------
                    advice_date: toNull(this.form.adviceDate),
                    advising_lawyer_id: toNumber(this.form.advisingLawyerId),
                    advice_status: toNull(this.form.adviceStatus),
                    advice_summary: toNull(this.form.adviceSummary),
                    recommended_action: toNull(this.form.recommendedAction),
                    client_decision: this.form.clientDecision,
                    decision_date: this.isAwaiting ? null : toNull(this.form.decisionDate),
                    client_note: toNull(this.form.clientNote),
                    // ---------- B · Case Identification ----------
                    internal_case_no: internalCaseNo,                     // null เมื่อยังไม่ Proceed
                    black_no: caseVal(toNull(this.form.blackNo)),
                    client_id: toNumber(this.form.clientId),              // bigint
                    red_no: caseVal(toNull(this.form.redNo)),
                    charge: caseVal(toNull(this.form.charge)),
                    court: caseVal(toNumber(this.form.court)),            // int
                    department: caseVal(toNumber(this.form.department)),  // int
                    case_type: caseVal(toNumber(this.form.caseType)),     // int
                    court_level: caseVal(toNumber(this.form.courtLevel)), // int *
                    claim_amount: caseVal(toNumber(this.form.claimAmount)), // numeric
                    lawyer_id: caseVal(toNumber(this.form.lawyerId)),     // bigint
                    plaintiffs: caseVal(toNull(this.form.plaintiffs)),
                    defendants: caseVal(toNull(this.form.defendants)),
                    remark: caseVal(toNull(this.form.remark)),
                    case_status: toNumber(this.form.caseStatus),          // bigint
                    sales_order_id: toNumber(this.form.salesOrderId),     // F · ใช้ได้ทั้ง Proceed / Do not proceed
                    user_update: Number(localStorage.getItem(server.USER_ID)),
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                };
                try {
                    await this.$showLoader()
                    var res = [];
                    if (this.modeOperations == "New") {
                        datalist.user_create = Number(localStorage.getItem(server.USER_ID));
                        res = await api.dispute_resolution_add_docket(datalist)
                        var main_id = res.data.id;

                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(main_id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)
                        try {
                            const caseDetailResult = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

                            const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const timelineData = visibilityResult.data || [];

                            caseInfo.status = timelineData[0]?.status || '';
                            caseInfo.lastUpdated = timelineData[0]?.status_time || '';

                            const latestUpdate = {
                                message: timelineData[0]?.status_note || '',
                                date: timelineData[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo,
                                    latestUpdate,
                                    timelineData,
                                    caseId: Number(main_id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline
                        //add payment invoice
                        // ผูก Invoice ได้ทุกสถานะยกเว้น Awaiting decision
                        if (!this.isAwaiting && this.form.invoiceId) {
                            try {
                                // อัปเดตสถานะ Quotation: InProgress → Invoiced (ถ้ามี Quotation)
                                if (this.form.salesOrderId) {
                                    try {
                                        const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.form.salesOrderId));
                                        if (resQuotations.data.status == "InProgress") {
                                            var dataupdateStatusInvoiced = {
                                                status: "Invoiced"
                                            }
                                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatusInvoiced)
                                        }
                                    } catch (error) {
                                        console.log("loadQuotations Error")
                                    }
                                }

                                var dataadd_payment_invoice = {
                                    inv_id: Number(this.form.invoiceId),
                                    module_name: "Litigations",
                                    module_id: Number(main_id),
                                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                    department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
                                    quotation_id: toNumber(this.form.salesOrderId),
                                }
                                await api.billing_expense_create_payment_invoice(dataadd_payment_invoice)
                            } catch (paymentInvoiceError) {
                                console.error("Link payment invoice failed:", paymentInvoiceError);
                                // ไม่ throw ต่อ — ไม่ให้กระทบการบันทึกทนายร่วม/วันนัด/ไฟล์แนบ
                            }
                        }
                        //end add payment invoice

                        // ทนายร่วม + วันนัด: บันทึกทุกอย่างที่กรอกไว้ ไม่ว่าลูกค้าจะตัดสินใจแบบไหน
                        // (กรณีกรอกตอน Proceed แล้วเปลี่ยนเป็นสถานะอื่นก่อนกด Save ข้อมูลจะไม่หาย)
                        {
                            if (this.additionalLawyers.length > 0) {
                                for (const item of this.additionalLawyers) {
                                    var dataAdditionalLawyers = {
                                        litigation_docket_id: main_id,
                                        user_id: item,
                                        user_create: Number(localStorage.getItem(server.USER_ID)),
                                        user_update: Number(localStorage.getItem(server.USER_ID))
                                    }
                                    await api.dispute_resolution_add_additional_lawyers(dataAdditionalLawyers)
                                }

                            }

                            for (const item of this.form.hearings) {
                                if (item.date != "" && item.time != "" && item.topic != "") {
                                    var dataaddhearings = {
                                        litigation_docket_id: Number(main_id),
                                        topic: item.topic,
                                        date: item.date,
                                        time: item.time,
                                        user_create: Number(localStorage.getItem(server.USER_ID)),
                                        user_update: Number(localStorage.getItem(server.USER_ID))
                                    };
                                    await api.dispute_resolution_add_hearings(dataaddhearings);
                                }
                            }
                        }

                        // เอกสารแนบ: อัปโหลดทุกไฟล์ที่แนบไว้ (เก็บข้อมูลไว้เสมอ)
                        if (this.form.files.length > 0) {
                            for (const item of this.form.files) {
                                let formData = new FormData();
                                formData.append("file", item.raw);
                                formData.append("id", Number(main_id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                                await api.dispute_resolution_upload_file(formData)
                            }
                        }

                    } else {
                        await api.dispute_resolution_update_docket(Number(this.$route.params.id), datalist)
                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(this.$route.params.id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)

                        try {
                            const caseDetailResultEdit = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const caseInfoEdit = { ...(caseDetailResultEdit.data?.[0] || {}) };

                            const visibilityResultEdit = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const timelineDataEdit = visibilityResultEdit.data || [];

                            caseInfoEdit.status = timelineDataEdit[0]?.status || '';
                            caseInfoEdit.lastUpdated = timelineDataEdit[0]?.status_time || '';

                            const latestUpdateEdit = {
                                message: timelineDataEdit[0]?.status_note || '',
                                date: timelineDataEdit[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo: caseInfoEdit,
                                    latestUpdate: latestUpdateEdit,
                                    timelineData: timelineDataEdit,
                                    caseId: Number(this.$route.params.id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline
                        //add payment invoice
                        // ผูก Invoice ได้ทุกสถานะยกเว้น Awaiting decision
                        if (!this.isAwaiting && this.form.invoiceId) {
                            try {
                                // อัปเดตสถานะ Quotation: InProgress → Invoiced (ถ้ามี Quotation)
                                if (this.form.salesOrderId) {
                                    try {
                                        const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.form.salesOrderId));
                                        if (resQuotations.data.status == "InProgress") {
                                            var dataupdateStatusInvoiced = {
                                                status: "Invoiced"
                                            }
                                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatusInvoiced)
                                        }
                                    } catch (error) {
                                        console.log("loadQuotations Error")
                                    }
                                }

                                var dataadd_payment_invoice = {
                                    inv_id: Number(this.form.invoiceId),
                                    module_name: "Litigations",
                                    module_id: Number(this.$route.params.id),
                                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                    department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
                                    quotation_id: toNumber(this.form.salesOrderId),
                                }
                                await api.billing_expense_create_payment_invoice(dataadd_payment_invoice)
                            } catch (paymentInvoiceError) {
                                console.error("Link payment invoice failed:", paymentInvoiceError);
                                // ไม่ throw ต่อ — ไม่ให้กระทบการบันทึกทนายร่วม/วันนัด/ไฟล์แนบ
                            }
                        }
                        //end add payment invoice

                        //edit ทนายร่วม — diff ตามที่เลือกไว้ (ทุกสถานะ)
                        // Awaiting / Declined ช่องล็อกอยู่ แก้ไม่ได้ → ถ้ามีการเปลี่ยน แปลว่าแก้ตอน Proceed แล้วค่อยเปลี่ยนสถานะ
                        // จึงบันทึกตามที่แก้ไว้ ไม่ทิ้งข้อมูล
                        const oldIds = this.originalAdditionalLawyers;
                        const newIds = this.additionalLawyers;

                        // ตัวที่เพิ่มใหม่ = อยู่ใน new แต่ไม่อยู่ใน old
                        const added = newIds.filter(id => !oldIds.includes(id));

                        // ตัวที่ถูกลบ = อยู่ใน old แต่ไม่อยู่ใน new
                        const removed = oldIds.filter(id => !newIds.includes(id));

                        // insert ตัวที่เพิ่ม
                        for (const item of added) {
                            await api.dispute_resolution_add_additional_lawyers({
                                litigation_docket_id: Number(this.$route.params.id),
                                user_id: item,
                                user_create: Number(localStorage.getItem(server.USER_ID)),
                                user_update: Number(localStorage.getItem(server.USER_ID))
                            });
                        }

                        // delete ตัวที่ถูกเอาออก
                        for (const item of removed) {
                            await api.dispute_resolution_delete_additional_lawyer_by_user(
                                Number(this.$route.params.id),
                                item
                            );
                        }

                        //  วันนัดพิจารณาคดี / วันนัดสืบพยาน
                        // บันทึกตามที่แก้ไว้ทุกสถานะ (ไม่ลบข้อมูลเดิมเพราะเปลี่ยนการตัดสินใจของลูกค้า)
                        {
                            // ----- ลบตัวที่ผู้ใช้กดลบ (ของเดิม) -----
                            for (const hid of this.deletedHearings) {
                                await api.dispute_resolution_delete_hearings(hid);
                            }

                            for (const item of this.form.hearings) {
                                // ข้ามแถวที่กรอกไม่ครบ
                                if (item.date == "" || item.time == "" || item.topic == "") continue;

                                if (item.id && item.id !== 0) {
                                    // ----- ของเดิม → update -----
                                    await api.dispute_resolution_update_hearings(item.id, {
                                        topic: item.topic,
                                        date: item.date,
                                        time: item.time,
                                        user_update: Number(localStorage.getItem(server.USER_ID)),
                                    });
                                } else {
                                    // ----- ของใหม่ (id = 0) → insert -----
                                    await api.dispute_resolution_add_hearings({
                                        litigation_docket_id: Number(this.$route.params.id),
                                        topic: item.topic,
                                        date: item.date,
                                        time: item.time,
                                        user_create: Number(localStorage.getItem(server.USER_ID)),
                                        user_update: Number(localStorage.getItem(server.USER_ID)),
                                    });
                                }
                            }
                        }

                        // ----- เอกสารแนบ (ทำงานเหมือนข้อมูลคดี) -----
                        // ลบตัวที่ผู้ใช้กดลบ + อัปโหลดไฟล์ใหม่ (ทุกสถานะ — ไม่ลบไฟล์เพราะเปลี่ยนการตัดสินใจของลูกค้า)
                        {
                            // ----- ลบไฟล์เดิมที่ผู้ใช้กดลบ -----
                            for (const f of this.deletedFiles) {
                                await api.dispute_resolution_delete_file(Number(this.$route.params.id), f.id, f.name);
                            }

                            // ----- อัปโหลดเฉพาะไฟล์ใหม่ (ไฟล์เดิมข้าม) -----
                            for (const item of this.form.files) {
                                if (item.isExisting) continue;   // ไฟล์เดิมจาก server ไม่ต้อง upload ซ้ำ
                                let formData = new FormData();
                                formData.append("file", item.raw);
                                formData.append("id", Number(this.$route.params.id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                                await api.dispute_resolution_upload_file(formData);
                            }
                        }
                    }
                    await this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: this.modeOperations == "New" ? "เพิ่มสำเร็จ" : "แก้ไขสำเร็จ",
                        text: this.modeOperations == "New"
                            ? "เพิ่มข้อมูลคดีเรียบร้อยแล้ว"
                            : "บันทึกการแก้ไขเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                    try {
                        // เปลี่ยนสถานะ Quotation ได้ทุกสถานะยกเว้น Awaiting decision
                        if (!this.isAwaiting && this.quotationscheckstatus == "Submitted") {


                            var dataupdateStatus = {
                                status: "InProgress"
                            }
                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatus)
                        }
                    } catch (quotationsError) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                    if (mode == "Save") {

                        if (this.modeOperations == "New") {
                            this.$router.push(`/dispute-resolution-docket/${res.data.id}`);
                        } else {
                            this.$router.go(0);
                        }
                    } else {

                        var customer_name_master_show = this.clientList.find(
                            item => item.id === this.form.clientId
                        )?.name

                        var dataPush = {
                            customer_name_master: customer_name_master_show,
                            module_id: 0,
                            quotation_id: toNumber(this.form.salesOrderId),
                        }
                        if (this.modeOperations == "New") {
                            dataPush.module_id = Number(res.data.id);
                        } else {
                            dataPush.module_id = Number(this.$route.params.id);
                        }

                        this.$router.push({
                            path: `/new-free-invoice/0/invoice/D/${this.form.clientId}/Litigations`,
                            query: dataPush,
                        });
                    }
                } catch (error) {
                    await this.$hideLoader();
                    Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }
            } else {
                // กรณี rule อื่นใน v-form ไม่ผ่าน → ใช้ dialog รูปแบบเดียวกัน
                this.showMissingFieldsDialog();
            }
        },
        onCancel() {
            this.$router.push(`/litigation-overview`);
        },
    },
    beforeDestroy() {
        this.form.files.forEach(f => {
            if (f.raw && f.url) URL.revokeObjectURL(f.url);
        });
    }
};
